export default __webpack_public_path__ + "static/media/guesty_lite_step9.2d668ab4.png";